import Vue from 'vue';
import index from './index.vue';
import fundscanner from '../store/module';
import MFScanner from '../components/MFScanner.vue';


const store = new Vuex.Store({
    modules: {
        fundscanner
    }
});

const router = new VueRouter({
    mode: "hash",
    hashbang: true,
    history: true,
    scrollBehavior (to, from, saved) {
            return { x: 0, y: 0}
    },
    routes: [{
        path: '/',
        component: MFScanner
    }]
});

router.afterEach((to, from) => {
    window.scrollTo(0, 0);
});

require('../less/global.less');

const app = new Vue({ store, router, ...index });

if (window.AUTO_MOUNT !== false) {
    const appEl = document.getElementById('app');
    if (appEl){
        app.$mount('#app');
    }
}

window.fndscannerapp = app;
